import React, {useContext, useState} from 'react';
import Box from '@mui/material/Box';
import SearchComponent from '../../../common/SearchComponent/SearchComponent';
import Typography from '@mui/material/Typography';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import LoanEntryOne from './LoanEntryOne';
import LoanEntryTwo from './LoanEntryTwo';
import LoanEntryThree from './LoanEntryThree';
import {useNavigate} from 'react-router';
import {catalogueApi} from '../../../services/CatalogueServices';
import FileUpload from '../../../common/ImageUpload/FileUpload';
import {loanApi} from '../../../services/LoanServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import {DispatchContext} from '../../../store';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function LoanRequest() {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const availableData = loans?.[0] || {};
  const [loanImgIds, setLoanImgIds] = useState([]);
  const code = 'en';
  const [searched, setSearched] = useState(false);

  const handleSearch = (searchAccession) => {
    if (searchAccession.trim() !== '') {
      catalogueApi('get', null, {search: searchAccession}).then(res => {
        setLoans({
          ...res?.data,
        });
      })
    }
  }

  const handleClear = () => {
    setLoans([]);
  };


  const getStringValue = (value) => {
    if (!value) return '';
    if (typeof value === 'object') {
      return value?.name || value?.code || '';
    }
    return value;
  };

  const onSubmit = (values) => {
    const loanValues = {
      museum_id: values?.museum_id,
      accession_no: getStringValue(values?.accession_no),
      catalogue_id: values?.id,
      duration: parseInt(values?.duration) || 0,
      duration_unit: values?.duration_unit,
      issue_date: values?.issue_date,
      return_date: values?.return_date,
      attachment_ids: loanImgIds?.map((val) => val?.id || val),
      translations: {
        en: {
          condition: getStringValue(values?.condition),
          purpose: getStringValue(values?.purpose),
          agency_loaned_to: getStringValue(values?.agency_loaned_to),
          recommendation: getStringValue(values?.recommendation)
        }
      }
    }
    loanApi('post', {...loanValues}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Request sent successful'}
      });
      navigate(`/management/artifact-managements`)
    })
  }

  return (
    <PageWrapper>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Loan Request</Typography>
        <Box sx={{ml: {sm: 5, xs: 0}}}>
          <SearchComponent onSearch={handleSearch} searched={searched} setSearched={setSearched}
                           onClear={handleClear} placeholder={'Enter accession number'}/>
        </Box>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={availableData}
              onSubmit={onSubmit}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            {searched &&
            <Box sx={{mb: {sm: 4, xs: 2}}}>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <LoanEntryOne code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <LoanEntryTwo code={code}/>
                </Grid>
                <Grid item sm={4} xs={12}>
                  <LoanEntryThree code={code}/>
                </Grid>
              </Grid>
              <Box className={'dotted-divider'}/>
              <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                  <Card className={'box-shadow'} sx={{p: 4}}>
                    <FileUpload setImageId={setLoanImgIds}/>
                  </Card>
                </Grid>
              </Grid>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Submit</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            }
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}